<template>
  <div class="custom-select-wrapper" :class="{ open: open }" @click.stop="toggleSelect">
    <div class="select-trigger">
      <span class="trigger-text">{{ currentLabel }}</span>
      <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
    </div>

    <div class="options-container">
      <div
        v-for="item in options"
        :key="item.value"
        class="option"
        :class="{ selected: item.value === modelValue }"
        @click.stop="select(item.value)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { computed, onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  placeholder: {
    type: String,
    default: '请选择'
  }
})

const emit = defineEmits(['update:modelValue'])
const open = ref(false)

const currentLabel = computed(() => {
  const option = props.options.find((item) => item.value === props.modelValue)
  return option?.label || props.modelValue || props.placeholder
})

const toggleSelect = () => {
  open.value = !open.value
}

const select = (value) => {
  emit('update:modelValue', value)
  open.value = false
}

const close = () => {
  open.value = false
}

onMounted(() => {
  window.addEventListener('click', close)
})

onUnmounted(() => {
  window.removeEventListener('click', close)
})
</script>
